import { OnboardingInvitationsComponent } from './pages/onboarding/onboarding-invitations/onboarding-invitations.component';
import { OnboardingEnterpriseComponent } from './pages/onboarding/onboarding-enterprise/onboarding-enterprise.component';
import { OnboardingPasswordComponent } from './pages/onboarding/onboarding-password/onboarding-password.component';
import { AlertModalComponent } from './modals/alert-modal/alert-modal.component';
import { FooterComponent } from './components/footer/footer.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { OnboardingLoginComponent } from './pages/onboarding/onboarding-login/onboarding-login.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { MemberModalComponent } from './modals/member-modal/member-modal.component';
import { AccessRequestComponent } from './pages/access/access-request/access-request.component';
import { AccessAllowComponent } from './pages/access/access-allow/access-allow.component';
import { AccessDoneComponent } from './pages/access/access-done/access-done.component';
import { AccessEnterprisesComponent } from './pages/access/access-enterprises/access-enterprises.component';
import { FilterModalComponent } from './modals/filter-modal/filter-modal.component';
import { PasswordResetRequestComponent } from './pages/password-reset/password-reset-request/password-reset-request.component';
import { PasswordResetChangeComponent } from './pages/password-reset/password-reset-change/password-reset-change.component';
import { PasswordResetDoneComponent } from './pages/password-reset/password-reset-done/password-reset-done.component';
import { PasswordResetCodeComponent } from './pages/password-reset/password-reset-code/password-reset-code.component';
import { DocumentCreateModalComponent } from './modals/document-create-modal/document-create-modal.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { ShareCreateModalComponent } from './modals/share-create-modal/share-create-modal.component';
import { MailModalComponent } from './modals/mail-modal/mail-modal.component';
import { ContactModalComponent } from './modals/contact-modal/contact-modal.component';
import { LoadingComponent } from './components/loading/loading.component';
import { BankInformationsComponent } from './modals/bank-informations/bank-informations.component';
import { UserCreateModalComponent } from './modals/user-create-modal/user-create-modal.component';
import { DocumentManagerComponent } from './components/document-manager/document-manager.component';
import { ShareModalComponent } from './modals/share-modal/share-modal.component';
import { InsuredExportModalComponent } from './modals/insured-export-modal/insured-export-modal.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { StatCardComponent } from './components/stat-card/stat-card.component';
import { UserInitialsComponent } from './components/user-initials/user-initials.component';
import { CopyComponent } from './components/app-copy/copy.component';
import { EditableInputComponent } from './components/editable-input/editable-input.component';
import { NaPipe } from './pipes/na.pipe';
import { EllipsePipe } from './pipes/ellipse.pipe';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { FilterUserModalComponent } from './modals/filter-user-modal/filter-user-modal.component';
import { SelectComponent } from './components/select/select.component';
import { RadiationModalComponent } from './modals/radiation-modal/radiation-modal.component';
import { RequiredFieldsModalComponent } from './modals/required-fields-modal/required-fields-modal.component';
import { EditCellModalComponent } from './modals/edit-cell-modal/edit-cell-modal.component';
import { InseeFormatDirective } from './directives/insee-format.directive';
import { LoginTwoFactorModalComponent } from './modals/login-two-factor-modal/login-two-factor-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    AlertModalComponent,
    OnboardingLoginComponent,
    OnboardingPasswordComponent,
    OnboardingEnterpriseComponent,
    OnboardingInvitationsComponent,
    PaginationComponent,
    SelectComponent,
    MemberModalComponent,
    AccessRequestComponent,
    AccessAllowComponent,
    AccessEnterprisesComponent,
    AccessDoneComponent,
    FilterModalComponent,
    FilterUserModalComponent,
    PasswordResetRequestComponent,
    PasswordResetCodeComponent,
    PasswordResetChangeComponent,
    PasswordResetDoneComponent,
    DocumentCreateModalComponent,
    ShareModalComponent,
    FileUploaderComponent,
    ToggleComponent,
    ShareCreateModalComponent,
    MailModalComponent,
    ContactModalComponent,
    LoadingComponent,
    BankInformationsComponent,
    UserCreateModalComponent,
    DocumentManagerComponent,
    InsuredExportModalComponent,
    SidebarComponent,
    StatCardComponent,
    UserInitialsComponent,
    CopyComponent,
    EditableInputComponent,
    NaPipe,
    EllipsePipe,
    StatusBadgeComponent,
    RadiationModalComponent,
    RequiredFieldsModalComponent,
    EditCellModalComponent,
    InseeFormatDirective,
    LoginTwoFactorModalComponent,
  ],
  exports: [
    StatCardComponent,
    PaginationComponent,
    UserInitialsComponent,
    StatusBadgeComponent,
    NaPipe,
    EllipsePipe,
    HeaderComponent,
    FooterComponent,
    AlertModalComponent,
    OnboardingLoginComponent,
    OnboardingPasswordComponent,
    OnboardingEnterpriseComponent,
    OnboardingInvitationsComponent,
    SelectComponent,
    MemberModalComponent,
    DocumentCreateModalComponent,
    ShareModalComponent,
    FileUploaderComponent,
    FilterUserModalComponent,
    ToggleComponent,
    ShareCreateModalComponent,
    MailModalComponent,
    ContactModalComponent,
    LoadingComponent,
    BankInformationsComponent,
    UserCreateModalComponent,
    InsuredExportModalComponent,
    SidebarComponent,
    EditableInputComponent,
    RadiationModalComponent,
    RequiredFieldsModalComponent,
    EditCellModalComponent,
    InseeFormatDirective,
    LoginTwoFactorModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppCommonModule {}
